import { Alert, HFlow, Text, VFlow } from 'bold-ui'
import { ReactComponent as Relatorio } from 'images/side-menu/relatorios.svg'
import React from 'react'

import gifAtendimentos from '../../images/novidades/gif_atendimentos.gif'
import gifOperacionais from '../../images/novidades/gif_operacionais.gif'
import gifRascunhoCds from '../../images/novidades/gif_rascunho_cds.gif'
import gifRelatorio from '../../images/novidades/gif_relatorios.gif'
import gifVacinacao from '../../images/novidades/gif_vacinacao.gif'
import imgAbsenteismo from '../../images/novidades/img_absenteismo.png'
import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalPanelV4_30() {
  if (!process.env.REACT_APP_VERSION) {
    return (
      <Alert type='danger' inline>
        Nenhuma informação sobre versões anteriores está disponível.
      </Alert>
    )
  }

  return (
    <VFlow>
      <VFlow vSpacing={1}>
        <Text fontWeight='bold'>Módulos com novidades:</Text>
        <HFlow hSpacing={5}>
          <VFlow vSpacing={0.2}>
            <Text component='li'>Relatórios gerenciais</Text>
            <Text component='li'>Relatórios operacionais</Text>
            <Text component='li'>Tabela de relatórios</Text>
            <Text component='li'>Rascunho para as fichas CDS</Text>
          </VFlow>
        </HFlow>
        <NewsHeadingSection
          title='Relatório gerencial de atendimentos'
          icon={<Relatorio style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              Este relatório gerencial apresenta informações relacionadas aos atendimentos individuais e odontológicos
              de acordo com os diversos filtros disponíveis. O relatório traz melhorias no componente de período, dando
              a possibilidade do profissional selecionar meses e semanas, além de um período personalizado.
            </Text>
            <img src={gifAtendimentos} style={{ width: '100%' }} alt='Gif Relatório gerencial de atendimentos' />
          </VFlow>
        </NewsHeadingSection>
        <NewsHeadingSection
          title='Relatório gerencial de vacinação'
          icon={<Relatorio style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              O relatório gerencial de vacinação apresenta informações quantitativas relacionadas as vacinações
              realizadas. Os dados são apresentados em uma tabela dinâmica, construída pelo usuário, arrastando os
              campos disponíveis para linhas e colunas e selecionando a forma de apresentação das informações. Além
              disso, também tem a opção de exportar o relatório para um arquivo no formato .csv.
            </Text>
            <img src={gifVacinacao} style={{ width: '100%' }} alt='Gif Relatório gerencial de vacinação' />
          </VFlow>
        </NewsHeadingSection>
        <NewsHeadingSection
          title='Relatório gerencial de absenteísmo'
          icon={<Relatorio style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>Foram incluídos os campos CBO e Faixa etária.</Text>
            <img src={imgAbsenteismo} style={{ width: '100%' }} alt='Imagem Relatório gerencial de absenteísmo' />
          </VFlow>
        </NewsHeadingSection>
        <NewsHeadingSection
          title='Relatórios operacionais'
          icon={<Relatorio style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              A geração de relatórios operacionais de "Risco Cardiovascular", "Gestante/Puérpera" e "Crianças Menores de
              5 Anos" pelo módulo de relatórios foi descontinuada. A partir desta versão esses relatórios são gerados
              exclusivamente pelo módulo de acompanhamento de condições de saúde.
            </Text>
            <img src={gifOperacionais} style={{ width: '100%' }} alt='Gif Relatórios operacionais' />
          </VFlow>
        </NewsHeadingSection>
        <NewsHeadingSection
          title='Tabela de relatórios processados'
          icon={<Relatorio style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              A partir dessa versão, os relatórios de produção, consolidados e de cadastro territorial possuirão uma
              tabela com os relatórios gerados nos últimos 7 dias. Nesta tabela, os últimos cinco relatórios solicitados
              ficarão armazenados possibilitando o download posterior das informações.
            </Text>
            <img src={gifRelatorio} style={{ width: '100%' }} alt='Gif Relatórios operacionais' />
          </VFlow>
        </NewsHeadingSection>
        <NewsHeadingSection
          title=' Rascunho para as fichas CDS'
          icon={<Relatorio style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              Nesta versão, as fichas são pré-salvas em formato de rascunho, evitando que os dados se percam. Isso não
              retira a necessidade do usuário salvar as fichas. Quando existirem fichas em rascunho o PEC irá sinalizar
              para o usuário a necessidade de salvá-las.
            </Text>
            <img src={gifRascunhoCds} style={{ width: '100%' }} alt='Gif Rascunho fichas CDS' />
          </VFlow>
        </NewsHeadingSection>
      </VFlow>
    </VFlow>
  )
}
